import React, { useState } from 'react';
import { Box, Button, Grid, IconButton, Drawer, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu'; // Import the menu icon
import CloseIcon from '@mui/icons-material/Close'; // Import the close icon
import { Link } from 'react-router-dom';
import './RentStyle.css'
const RentHeader = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  
  const handleLogin = () => {
    window.open('https://app.rentid.io/login', '_blank');
  };


  

  return (
    <>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingY: '2%' }}
      >
        {/* Left - Logo */}
        <Grid item xs={6} md={6}>
          <Box>
            <Link to='/'>
              {/* <img src={logo} alt="logo" style={{ height: 'auto', width: '117px' }} /> */}
              <h1 className="sitename">
                <img src="/img/Rentid-white.svg" alt="desktop logo" className="desktop-logo" />
                <img src="/img/mobile-logo.svg" alt="mobile logo" className="mobile-logo" />
              </h1>
            </Link>
          </Box>
        </Grid>

        {/* Right - Buttons and Hamburger Menu */}
        <Grid item xs={6} md={6}>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' }, // Hide buttons on small screens
              justifyContent: 'flex-end',
              gap: '20px',
              marginRight: '30px',
            }}
          >
            <div className="dropdown">
              <a className="loginbtn d-lg-block d-none" href="https://app.rentid.io/login">
                Login
              </a>
            </div>

            <Button
            data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
              // onClick={handleApplybtn}
              sx={{
                width: '166px',
                height: '45px',
                fontSize: '15px',
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '24px',
                padding: '12px 16px',
                fontWeight: 600,
                fontFamily: 'Manrope',
                textTransform: 'none',
                "&:hover": {
                  background: 'transparent',
                  color: 'white',
                  textAlign: 'center',
                },
              }}
              variant="contained"
            >
              Apply For Beta
            </Button>
          </Box>
          {/* Hamburger Icon for Small Screens */}
          <Box
            sx={{
              display: { xs: 'block', md: 'none' }, // Show only on small screens
              textAlign: 'right',
              marginRight: '16px',
            }}
          >
            <IconButton onClick={() => setIsDrawerOpen(true)} sx={{ color: 'white' }}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* Drawer for Small Screens */}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: '250px',
            backgroundColor: '#333', // Adjust drawer background color
            color: 'white',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '16px',
            gap: '20px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6">Menu</Typography>
            <IconButton onClick={() => setIsDrawerOpen(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Button
            onClick={handleLogin}
            sx={{
              color: 'white',
              border: '1px solid white',
              borderRadius: '8px',
              textTransform: 'none',
            }}
            variant="outlined"
          >
            Login
          </Button>

          {process.env.REACT_APP_ENABLE_BETA === "true" && (<Button
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"

            sx={{
              backgroundColor: 'white',
              color: 'black',
              borderRadius: '8px',
              textTransform: 'none',
            }}
            variant="contained"
          >
            Apply For Beta
          </Button>)}
          
        </Box>
      </Drawer>

    </>
  );
};

export default RentHeader;
